import { render } from "./modalReceptBook.vue?vue&type=template&id=18a1079b"
import script from "./modalReceptBook.vue?vue&type=script&lang=js"
export * from "./modalReceptBook.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace\\ef_vue_icecreator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__